/* Accessible predictive search — combobox pattern fix (WCAG 2.1: 1.3.1, 2.1.1, 4.1.2, 4.1.3) */
(function () {
  'use strict';
  var PAIRS = [['search-desktop','search-results-desktop'],['search-mobile','search-results-mobile']];
  var OPT = '[role="option"]';
  var HL = 'wcag-search-focused';
  var live, liveTimer, flip = false, combos = [];

  /* 1. Live region: created once, up front, so later updates are announced */
  function ensureLive() {
    if (live && document.body && document.body.contains(live)) return live;
    live = document.getElementById('search-a11y-status');
    if (!live) {
      live = document.createElement('div');
      live.id = 'search-a11y-status';
      live.setAttribute('role','status');
      live.setAttribute('aria-live','polite');
      live.setAttribute('aria-atomic','true');
      live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap';
      (document.body || document.documentElement).appendChild(live);
    }
    return live;
  }
  function announce(msg) {
    var el = ensureLive();
    clearTimeout(liveTimer);
    el.textContent = '';
    liveTimer = setTimeout(function () { flip = !flip; el.textContent = flip ? msg : msg + '\u00A0'; }, 150);
  }
  function muteLegacy() { /* stop ada-pro's stale region from double-speaking */
    var l = document.getElementById('search-live-status');
    if (l && l.getAttribute('aria-hidden') !== 'true') {
      l.textContent = ''; l.removeAttribute('aria-live'); l.removeAttribute('role'); l.setAttribute('aria-hidden','true');
    }
  }

  function Combo(inputId, panelId) {
    var input = document.getElementById(inputId), panel = document.getElementById(panelId);
    if (!input || !panel) return null;
    var options = [], index = -1, lastSig = '', gseq = 0, raf = null;

    function isOpen() { return input.getAttribute('aria-expanded') === 'true'; }
    function set(el, name, val) { if (el.getAttribute(name) !== val) el.setAttribute(name, val); }

    /* 2. Valid listbox structure */
    function structure() {
      if (panel.hasAttribute('aria-modal')) panel.removeAttribute('aria-modal');
      set(panel, 'role', 'listbox');
      if (!panel.getAttribute('aria-label')) set(panel, 'aria-label', 'Search suggestions');
      var vab = panel.querySelector('button'); /* "View all results" is not a legal listbox child */
      if (vab && vab.getAttribute('role') !== 'option') {
        set(vab,'role','option'); set(vab,'aria-selected','false'); set(vab,'tabindex','-1'); set(vab,'data-a11y-viewall','true');
      }
      Array.prototype.forEach.call(panel.querySelectorAll('strong'), function (lbl) {
        var sec = lbl.parentElement;
        while (sec && sec !== panel && !sec.querySelector(OPT)) sec = sec.parentElement;
        if (!sec || sec === panel) return;
        if (!lbl.id) lbl.id = panelId + '-group-' + (++gseq);
        set(sec, 'role', 'group'); set(sec, 'aria-labelledby', lbl.id);
      });
    }

    function paint() {
      options.forEach(function (o, i) {
        var on = i === index;
        set(o, 'aria-selected', on ? 'true' : 'false');
        o.classList.toggle(HL, on);
      });
      if (index < 0 || !options[index]) {
        if (input.hasAttribute('aria-activedescendant')) input.removeAttribute('aria-activedescendant');
      } else { set(input, 'aria-activedescendant', options[index].id); }
    }

    /* 3. Every rendered option gets a real id, and is removed from the tab sequence */
    function reindex() {
      structure();
      options = Array.prototype.slice.call(panel.querySelectorAll(OPT))
        .filter(function (o) { return o.getClientRects().length > 0; });
      options.forEach(function (o, i) {
        var id = panelId + '-option-' + i;
        if (o.id !== id) o.id = id;
        set(o, 'tabindex', '-1');
        var p = o.parentElement;
        while (p && p !== panel) { if (!p.getAttribute('role')) set(p, 'role', 'presentation'); p = p.parentElement; }
      });
      if (index >= options.length) index = -1;
      var ad = input.getAttribute('aria-activedescendant');
      if (ad === 'null' || ad === '') input.removeAttribute('aria-activedescendant');
      paint();
    }

    function move(step, jump) {
      reindex();
      if (!options.length) return;
      if (jump === 'first') index = 0;
      else if (jump === 'last') index = options.length - 1;
      else { index += step; if (index < 0) index = options.length - 1; if (index >= options.length) index = 0; }
      paint();
      var el = options[index];
      if (el && el.scrollIntoView) el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    function clear() { index = -1; paint(); }
    function activate() { var el = options[index]; if (el) { el.click(); return true; } return false; }
    function reopen() { input.dispatchEvent(new Event('input', { bubbles: true })); }

    /* 4. Announce the result count on every change */
    function report() {
      var q = input.value.trim();
      var sig = q + '|' + options.length + '|' + panel.querySelectorAll(OPT).length + '|' + (isOpen() ? 1 : 0);
      if (sig === lastSig) return;
      lastSig = sig;
      if (!q || !isOpen()) return;
      var real = options.filter(function (o) { return !o.hasAttribute('data-a11y-viewall'); });
      if (!real.length) { announce('No results found for ' + q); return; }
      var n = real.length;
      announce(n + (n === 1 ? ' result' : ' results') + ' found for ' + q +
        '. Use the up and down arrow keys to review results, Enter to open, Escape to dismiss.');
    }

    function sync() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; muteLegacy(); reindex(); report(); }); }

    new MutationObserver(sync).observe(panel, { childList: true, subtree: true, attributes: true,
      attributeFilter: ['aria-modal','aria-selected','role','id','tabindex','style','hidden'] });
    new MutationObserver(function () { if (!isOpen()) { clear(); lastSig = ''; } else { sync(); } })
      .observe(input, { attributes: true, attributeFilter: ['aria-expanded','aria-activedescendant'] });

    input.addEventListener('input', function () { index = -1; sync(); });
    input.addEventListener('focus', sync);

    var api = { input: input, panel: panel, isOpen: isOpen, move: move, clear: clear,
      activate: activate, reopen: reopen, sync: sync, get index() { return index; } };
    sync();
    return api;
  }

  function comboFor(t) { for (var i = 0; i < combos.length; i++) if (combos[i].input === t) return combos[i]; return null; }

  /* 5. One authoritative keyboard model (capture phase pre-empts the theme's duplicate handlers) */
  function onKey(e) {
    var c = comboFor(e.target);
    if (!c) return;
    var k = e.key, down = e.type === 'keydown';
    if (k === 'ArrowDown' || k === 'ArrowUp') {
      if (!c.isOpen()) {
        if (k === 'ArrowDown' && c.input.value.trim()) { e.preventDefault(); e.stopImmediatePropagation(); if (down) c.reopen(); }
        return;
      }
      e.preventDefault(); e.stopImmediatePropagation();
      if (down) c.move(k === 'ArrowDown' ? 1 : -1);
      return;
    }
    if ((k === 'Home' || k === 'End') && c.isOpen() && c.index >= 0) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (down) c.move(0, k === 'Home' ? 'first' : 'last');
      return;
    }
    if (k === 'Enter') {
      if (c.isOpen() && c.index >= 0) { e.preventDefault(); e.stopImmediatePropagation(); if (down) c.activate(); return; }
      if (!c.input.value.trim()) { /* stops the jump to the empty /search page */
        e.preventDefault(); e.stopImmediatePropagation();
        if (down) announce('Type a search term, then press Enter.');
      }
      return;
    }
    if (k === 'Escape' || k === 'Tab') { c.clear(); }
  }

  /* 6. Mobile decoy field + empty submit guard + search landmark */
  function fixForms() {
    combos.forEach(function (c) {
      var form = c.input.form || c.input.closest('form');
      if (!form) return;
      if (!form.getAttribute('role')) { form.setAttribute('role','search'); form.setAttribute('aria-label','Product search'); }
      if (!form.__a11yGuard) {
        form.__a11yGuard = true;
        form.addEventListener('submit', function (e) {
          if (!c.input.value.trim()) { e.preventDefault(); e.stopPropagation(); announce('Type a search term, then press Enter.'); c.input.focus(); }
        }, true);
      }
      Array.prototype.forEach.call(form.querySelectorAll('input[type="text"],input[type="search"]'), function (el) {
        if (el === c.input || el.name || el.__a11yDecoy) return;
        el.__a11yDecoy = true;
        el.setAttribute('aria-hidden','true');
        el.setAttribute('tabindex','-1');
        el.addEventListener('focus', function () { c.input.focus(); });
        el.addEventListener('input', function () {
          c.input.value = el.value; el.value = '';
          c.input.focus();
          c.input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });
    });
  }

  function init() {
    ensureLive(); muteLegacy();
    PAIRS.forEach(function (p) {
      for (var i = 0; i < combos.length; i++) if (combos[i].input.id === p[0]) return;
      var c = Combo(p[0], p[1]); if (c) combos.push(c);
    });
    fixForms();
  }

  document.addEventListener('keydown', onKey, true);
  document.addEventListener('keyup', onKey, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setTimeout(init, 1500);
  window.__searchA11y = { combos: function () { return combos; }, announce: announce };
})();

